import externalStrings from 'themes/[theme]/strings/external';

export default externalStrings;
